import i18n from "i18n";

const Messages = {
  Create: i18n.t('notifications.common.create', { dataType: i18n.t('labels.case') }),
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.case') }),
  Delete: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.case') }),
  Archive: i18n.t('notifications.insuranceCase.archive'),
  Unarchive: i18n.t('notifications.insuranceCase.unarchive'),
  Accept: i18n.t('notifications.insuranceCase.accept'),
  Reject: i18n.t('notifications.insuranceCase.reject'),
  Transmit: i18n.t('notifications.insuranceCase.transmit'),
  CreateDuplicate: i18n.t('notifications.insuranceCase.createDuplicate'),
  Status: i18n.t('notifications.insuranceCase.statusUpdate')
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Create = i18n.t('notifications.common.create', { dataType: i18n.t('labels.case') });
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.case') });
  Messages.Delete = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.case') });
  Messages.Archive = i18n.t('notifications.insuranceCase.archive');
  Messages.Unarchive = i18n.t('notifications.insuranceCase.unarchive');
  Messages.Accept = i18n.t('notifications.insuranceCase.accept');
  Messages.Reject = i18n.t('notifications.insuranceCase.reject');
  Messages.Transmit = i18n.t('notifications.insuranceCase.transmit');
  Messages.CreateDuplicate = i18n.t('notifications.insuranceCase.createDuplicate');
  Messages.Status = i18n.t('notifications.insuranceCase.statusUpdate');
});